export function GoodsIcon({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M13.333 6.66667C13.333 7.55072 12.9818 8.39857 12.3567 9.02369C11.7316 9.64881 10.8837 10 9.99967 10C9.11561 10 8.26777 9.64881 7.64264 9.02369C7.01752 8.39857 6.66633 7.55072 6.66633 6.66667M3.02735 6.16782L2.44402 13.1678C2.3187 14.6716 2.25604 15.4235 2.51024 16.0035C2.73357 16.5131 3.12052 16.9336 3.60982 17.1985C4.16673 17.5 4.92122 17.5 6.4302 17.5H13.5691C15.0781 17.5 15.8326 17.5 16.3895 17.1985C16.8788 16.9336 17.2658 16.5131 17.4891 16.0035C17.7433 15.4235 17.6806 14.6716 17.5553 13.1678L16.972 6.16782C16.8642 4.87396 16.8103 4.22703 16.5237 3.73738C16.2714 3.3062 15.8957 2.9605 15.4451 2.74487C14.9333 2.5 14.2841 2.5 12.9858 2.5L7.01353 2.5C5.71519 2.5 5.06601 2.5 4.55426 2.74487C4.10362 2.9605 3.72791 3.3062 3.4756 3.73738C3.18908 4.22703 3.13517 4.87396 3.02735 6.16782Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "GoodsIcon";
